
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M361.36 320a72.48 72.48 0 0121 68.24c-4.86 23-21.55 42.13-43.07 51.52a98.75 98.75 0 01-39.35 8.24H234a78.37 78.37 0 01-74.58-53.5 8.07 8.07 0 00-9.43-5.56l-15.65 3.65a8 8 0 00-6 10A110.28 110.28 0 00234 480h66a130.93 130.93 0 0052.12-10.91c33.54-14.6 58.16-46.18 63-82.44A104.52 104.52 0 00401.79 320zm-192.11-96h68.28l-39.37-19.61c-24.78-12.33-40-37.46-39.29-66.71a72.2 72.2 0 0140.23-63.34A98.53 98.53 0 01242.91 64h47.86a108.83 108.83 0 0195.51 56.91 8 8 0 0010.33 3.69l14.6-6.62a8.06 8.06 0 003.92-11A140.86 140.86 0 00290.77 32h-47.86a130.84 130.84 0 00-58.16 13.73c-35.72 17.86-57.9 53.82-57.9 95.21a102.1 102.1 0 0042.4 83.06zM504 256H8a8 8 0 00-8 8v16a8 8 0 008 8h496a8 8 0 008-8v-16a8 8 0 00-8-8z"}})])
          )
        }
      }
    